import epic from './epic';


export default epic;
